module.exports = __webpack_public_path__ + "static/media/19_Bild_1.834ac6b7.jpeg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle19/19_Bild_1.jpeg
 ** module id = 161
 ** module chunks = 0
 **/